import { useEffect } from 'react'
import {
  acquireNoKeyboardResize,
  releaseNoKeyboardResize,
} from '../utils/flutterStatusBar'

/**
 * 폼 풀페이지 전용: 화면에 있는 동안 키보드 시 웹뷰 리사이즈를 OFF.
 * → 입력칸 탭해도 하단 버튼이 키보드 따라 안 밀리고 **바닥에 고정**(포커스 입력은 자동 스크롤).
 * 화면을 벗어나면 원복(카운터 관리). 네이티브 브리지라 신 앱에서만 동작, 구 앱/웹은 무시.
 *
 * **입력 있는 바텀시트에선 쓰지 말 것** — 시트가 키보드 뒤로 숨음.
 */
export function useNoKeyboardResize(): void {
  useEffect(() => {
    acquireNoKeyboardResize()
    return () => releaseNoKeyboardResize()
  }, [])
}
